module.exports = __webpack_public_path__ + "static/img/img_2.8cd30e3f.jpg";